import api from './api';

export interface EmailSettings {
  id?: string;
  smtp_host: string;
  smtp_port: number;
  smtp_username: string;
  smtp_password: string;
  smtp_encryption: 'none' | 'tls' | 'ssl';
  from_name: string;
  from_email: string;
  reply_to_email: string;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface TestConnectionResult {
  success: boolean;
  message: string;
}

class EmailSettingsService {
  private baseUrl = '/crm/email-settings';

  async getSettings(): Promise<EmailSettings | null> {
    try {
      const response = await api.get(this.baseUrl);
      return response.data.data;
    } catch (error) {
      console.error('Error getting email settings:', error);
      return null;
    }
  }

  async saveSettings(settings: Omit<EmailSettings, 'id' | 'created_at' | 'updated_at'>): Promise<EmailSettings> {
    const response = await api.post(this.baseUrl, settings);
    return response.data.data;
  }

  async testConnection(settings: Partial<EmailSettings>): Promise<TestConnectionResult> {
    const response = await api.post(`${this.baseUrl}/test`, settings);
    return {
      success: response.data.success,
      message: response.data.message
    };
  }
}

export const emailSettingsService = new EmailSettingsService();
